import { useTranslation } from 'react-i18next';
import { timeFormatter } from 'pos-client/utils/dateHelpers.ts';

export const useJobSlotStartAndEndDisplayTimes = (
  startDate: string,
  endDate: string,
  isExpected: boolean
) => {
  const { t } = useTranslation();

  const start = new Date(startDate);
  const end = new Date(endDate);
  const startDisplay =
    `${isExpected ? t('common.date.expStart') : t('common.date.start')}: ` +
    timeFormatter.format(start);
  const endDisplay =
    `${isExpected ? t('common.date.expEnd') : t('common.date.end')}: ` +
    timeFormatter.format(end);

  return { startDisplay, endDisplay };
};
